import { BankIcon } from '@/shared/assets';
import { Typography } from '@/shared/ui';

interface OthersAssetsItemProps {
  othersCount: number;
  //othersSum: number;
}
export const OthersAssetsItem = ({
  //othersSum,
  othersCount,
}: OthersAssetsItemProps) => {
  return (
    <div className="flex h-[72px] items-center rounded-[20px] px-5 py-2 hover:bg-hover-base-500-hover">
      <div className="flex h-10 w-10 items-center justify-center rounded-full bg-base-300">
        <BankIcon className="h-5 w-[18px]" />
      </div>
      <Typography variant="16-r" className="ml-4">
        {othersCount} other accounts
      </Typography>
      {/* <Typography variant="16-r" className="ml-auto">
        {othersSum} £
      </Typography> */}
    </div>
  );
};
